import React, { useEffect, useState } from 'react'
import Joyride, { CallBackProps } from 'react-joyride'
import { useTourContext, TourStep } from '../../providers/TourContext'

const TourRunner: React.FC = () => {
  const { steps } = useTourContext()

  const [pendingSteps, setPendingSteps] = useState<TourStep[]>(() =>
    steps.filter((s) => localStorage.getItem(`tutorial_${s.id}_passed`) === null),
  )

  useEffect(() => {
    setPendingSteps(steps.filter((s) => localStorage.getItem(`tutorial_${s.id}_passed`) === null))
  }, [steps])

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { type, step, action } = data
    if (type === 'step:after' && 'id' in step && step?.id && action === 'close') {
      localStorage.setItem(`tutorial_${step.id}_passed`, 'true')
      setPendingSteps((prev) => prev.filter((s) => s.id !== step.id))
    }
  }

  if (pendingSteps.length === 0) return null

  return (
    <Joyride
      steps={pendingSteps}
      run={pendingSteps.length > 0}
      showSkipButton
      callback={handleJoyrideCallback}
      styles={{ options: { zIndex: 1100 } }}
    />
  )
}

export default TourRunner
